import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SubmitVerifyContainerMutationVariables = Types.Exact<{
  input: Types.SubmitVerifyContainerInput;
}>;


export type SubmitVerifyContainerMutation = { __typename?: 'Mutation', submitVerifyContainer: { __typename?: 'VerifyContainerPayload', verifyContainer?: { __typename?: 'VerifyContainerStateData', id: string, label: string, drop: string, status: Types.VerifyContainerStatus, submittedBy: string, submittedAt: Types.TDateISO, orderAssociations: Array<{ __typename?: 'VerifyContainerOrderAssociationData', orderId: string }>, scans: Array<{ __typename?: 'VerifyContainerScanData', barcode: string, itemId?: string | null, quantity: number, scannedAt: Types.TDateISO, scannedBy: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveVerifyContainerMutationVariables = Types.Exact<{
  input: Types.RemoveVerifyContainerInput;
}>;


export type RemoveVerifyContainerMutation = { __typename?: 'Mutation', removeVerifyContainer: { __typename?: 'VerifyContainerPayload', verifyContainer?: { __typename?: 'VerifyContainerStateData', id: string, label: string, status: Types.VerifyContainerStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SubmitOrderVerificationMutationVariables = Types.Exact<{
  input: Types.SubmitOrderVerificationInput;
}>;


export type SubmitOrderVerificationMutation = { __typename?: 'Mutation', submitOrderVerification: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, status: Types.OrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SubmitVerifyContainerDocument = new TypedDocumentString(`
    mutation SubmitVerifyContainer($input: SubmitVerifyContainerInput!) {
  submitVerifyContainer(input: $input) {
    verifyContainer {
      id
      label
      drop
      status
      submittedBy
      submittedAt
      orderAssociations {
        orderId
      }
      scans {
        barcode
        itemId
        quantity
        scannedAt
        scannedBy
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const RemoveVerifyContainerDocument = new TypedDocumentString(`
    mutation RemoveVerifyContainer($input: RemoveVerifyContainerInput!) {
  removeVerifyContainer(input: $input) {
    verifyContainer {
      id
      label
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SubmitOrderVerificationDocument = new TypedDocumentString(`
    mutation SubmitOrderVerification($input: SubmitOrderVerificationInput!) {
  submitOrderVerification(input: $input) {
    order {
      orderId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SubmitVerifyContainer: build.mutation<SubmitVerifyContainerMutation, SubmitVerifyContainerMutationVariables>({
      query: (variables) => ({ document: SubmitVerifyContainerDocument, variables })
    }),
    RemoveVerifyContainer: build.mutation<RemoveVerifyContainerMutation, RemoveVerifyContainerMutationVariables>({
      query: (variables) => ({ document: RemoveVerifyContainerDocument, variables })
    }),
    SubmitOrderVerification: build.mutation<SubmitOrderVerificationMutation, SubmitOrderVerificationMutationVariables>({
      query: (variables) => ({ document: SubmitOrderVerificationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSubmitVerifyContainerMutation, useRemoveVerifyContainerMutation, useSubmitOrderVerificationMutation } = injectedRtkApi;
